var map = {
	"./color-studio.scss": "../css/pages/color-studio.scss",
	"./detail-material-r.scss": "../css/pages/detail-material-r.scss",
	"./detail-materials.scss": "../css/pages/detail-materials.scss",
	"./faq-group.scss": "../css/pages/faq-group.scss",
	"./faq.scss": "../css/pages/faq.scss",
	"./how-to-use-drops.scss": "../css/pages/how-to-use-drops.scss",
	"./iphone-promo/index.scss": "../css/pages/iphone-promo/index.scss",
	"./locator/locator.scss": "../css/pages/locator/locator.scss",
	"./profile/common/profile-password-modal.scss": "../css/pages/profile/common/profile-password-modal.scss",
	"./profile/invite-friends.scss": "../css/pages/profile/invite-friends.scss",
	"./sitemap.scss": "../css/pages/sitemap.scss",
	"./sp-operators.scss": "../css/pages/sp-operators.scss",
	"./team.scss": "../css/pages/team.scss",
	"./ui-kit/ui-kit-buttons.scss": "../css/pages/ui-kit/ui-kit-buttons.scss",
	"./ui-kit/ui-kit-color-pallet.scss": "../css/pages/ui-kit/ui-kit-color-pallet.scss",
	"./ui-kit/ui-kit-tags.scss": "../css/pages/ui-kit/ui-kit-tags.scss",
	"./ui-kit/ui-kit-typography.scss": "../css/pages/ui-kit/ui-kit-typography.scss",
	"./ui-kit/ui-kit.scss": "../css/pages/ui-kit/ui-kit.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../css/pages sync recursive \\.scss$";